import { Routes } from '@angular/router';
import { AuthGuard } from '../../../core/auth.guard';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from '../../helper/custom-overlay-container.service';
import { provideToastConfig } from '@app/services/toast.service';
export const content: Routes = [
  {
    path: 'dealer',
    canActivate: [AuthGuard],
    loadChildren: () => import('../../components/dealer/dealer.routes').then(m => m.DEALER_ROUTES), providers: [provideNativeDateAdapter(), { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, provideToastConfig({ duration: 5000 }), { provide: OverlayContainer, useClass: CustomOverlayContainer }],
    data: {
      role: ['dealer']
    }
  },
];
 
export const gdccontent: Routes = [
  {
    path: 'tml',
    canActivate: [AuthGuard],
    loadChildren: () => import('../../components/tml/gdc.routes').then(m => m.TML_GDC_ROUTES), providers: [provideNativeDateAdapter(), { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, provideToastConfig({ duration: 5000 })],
    data: {
      role: ['gdc','approver']
    }
  },
];
export const callcentercontent: Routes = [
  {
    path: 'callcenter',
    canActivate: [AuthGuard],
    loadChildren: () => import('../../components/callcenter/callcenter.routes').then(m => m.CALLCENTER_ROUTES), providers: [provideNativeDateAdapter(), { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, provideToastConfig({ duration: 5000, position: 'top-right', preventDuplicates: true, closeButton: true, progressBar: true }), { provide: OverlayContainer, useClass: CustomOverlayContainer }],
    data: {
      role: ['call_centre']
    }
  },
];
// GdcModule
